import { useNavigate, useParams } from 'react-router-dom';
import CardLayout from '../../../components/Layout/CardLayout';
import request from '../../../request/request';
import useFetch from '../../../hooks/useFetch';
import LoaderLayout from '../../../components/Loader/LoaderLayout';
import { formDataConverter } from '../../../utils/necessaryFunctions';
// import PackageFormContainer from '../../../components/Forms/Websites/Package/PackageFormContainer';
import VisaFormContainer from '../../../components/Forms/Websites/Visa/VisaFormContainer';

const EditVisa = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { result, isLoading } = useFetch(() => request.getOne('visa', id));
    console.log('result visa id', result);

    // console.log("formValue EditVisa", formValue);
    const UpdateAboutUsHandler = (formValue) =>
        request.updateOne('visa', id, formValue, () => {
            navigate('/dashboard/website/visa');
        });
    return (
        <LoaderLayout isPending={isLoading}>
            <CardLayout title='Update Visa'>
                <VisaFormContainer apiHandler={UpdateAboutUsHandler} editData={result} />
            </CardLayout>
        </LoaderLayout>
    );
};

export default EditVisa;
